import { useQuery } from '@tanstack/react-query';
import { GovosApiRoutes, govosClient } from 'api/govos-api';
import { GovOsResult, ProfileData } from 'api/govos.types';
import { Navigate, Outlet } from 'react-router-dom';
import { RouteKey } from './AppRoutes';
import { ProtectedLayoutProps } from './RouteGuardAuthorized';

export function RouteGuardGuest({ redirectTo }: ProtectedLayoutProps) {
  const { data: user, isLoading } = useQuery({
    queryKey: [GovosApiRoutes.user()],
    queryFn: () =>
      govosClient
        .get<GovOsResult<ProfileData>>(GovosApiRoutes.user())
        .then((res) => (res.data.result === 'success' ? res.data.data : null))
  });

  if (user && !isLoading) {
    return <Navigate to={redirectTo ?? RouteKey.MANAGED_ONLINEDIENSTE} />;
  }

  return <Outlet />;
}
